<template>
  <div class="flex justify-center gap-2">
    <TButton
      v-if="pagination?.prev"
      :disabled="isDisabled"
      @click="changePage(pagination.prev)"
    >
      {{ t('actions.prev') }}
    </TButton>

    <TButton
      v-if="pagination?.next"
      :disabled="isDisabled"
      @click="changePage(pagination.next)"
    >
      {{ t('actions.next') }}
    </TButton>
  </div>
</template>

<script setup lang="ts">
import type { Pagination } from '@tryghost/content-api'

defineProps<{
  pagination?: Pagination
  isDisabled?: boolean
}>()

const { t } = useI18n()
async function changePage(page?: number) {
  await navigateTo({
    query: {
      page: page === 1 ? undefined : page,
    },
  })

  scrollToTop()
}
</script>
